export default function ModalOrderStatus(
  $uibModalInstance,
  $analytics,
  $state,
  Order,
  order,
  account,
  showOrdersLink
) {
  'ngInject';

  this.orderId = order.id;
  this.account = account;
  this.showOrdersLink = showOrdersLink;
  this.$analytics = $analytics;

  this.loading = true;
  Order.get({ id: this.orderId })
    .$promise.then((result) => {
      this.order = result;
    })
    .catch((err) => {
      console.error(err);
      this.error = true;
    })
    .finally(() => {
      this.paid = false;
      this.backordered = false;
      this.orderShipped = false;
      this.error = false;
      if (this.order.status == 'awaiting_payment') {
        // no changes
      } else if (this.order.status == 'on_hold') {
        this.paid = true;
        this.backordered = true;
      } else if (this.order.status == 'awaiting_shipment') {
        this.paid = true;
      } else if (this.order.status == 'shipped') {
        this.paid = true;
        this.orderShipped = true;
        this.order.service_code = this.order.service_code.replace(/_/g, ' ');
      } else {
        this.error = true;
      }

      this.loading = false;
    });

  this.trackingLink = () => {
    switch (this.order.carrier_code) {
      case 'fedex':
        return `https://www.fedex.com/apps/fedextrack/index.html?tracknumbers=${this.order.tracking_number}`;
      case 'stamps_com':
        return `https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=${this.order.tracking_number}`;
      case 'dhl_express':
        return `https://www.dhl.com/content/g0/en/express/tracking.shtml?AWB=${this.order.tracking_number}&brand=DHL`;
    }
  };

  this.viewAllOrders = () => {
    $uibModalInstance.dismiss('cancel');
    $state.go('settings.payment', { show_orders: true });
    this.$analytics.eventTrack(`view-all-orders`, { category: 'open', label: '' });
  };

  this.cancel = () => {
    $uibModalInstance.dismiss('cancel');
  };
}



// WEBPACK FOOTER //
// ./app/pages/settings/modal-order-status.js